import { gsap, ScrollTrigger } from '@hh/gsap.js'
gsap.registerPlugin(ScrollTrigger)

const containerHeight = document.getElementById('BlogArticles').offsetHeight
const secondColHeight = document.querySelector('.js-second-col').offsetHeight

const getRemainingPercent = (a, b) => {
  return Math.abs((a / b) * 100 - 100)
}

gsap.to('.js-first-col', {
  yPercent: 5,
  scrollTrigger: {
    trigger: '#BlogArticles',
    end: 'bottom bottom',
    scrub: 1,
  },
})

gsap.to('.js-second-col', {
  yPercent: getRemainingPercent(secondColHeight, containerHeight),
  scrollTrigger: {
    trigger: '#BlogArticles',
    end: 'bottom bottom',
    scrub: 1,
  },
})
